import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Heading from '@marvelapp/marvel-ui/heading';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import {
  getCommenterParam,
  getNextRedirectParam,
  getUrlWithRedirect,
  getSignupUrlWithRedirect,
} from 'marketing-website/utils/forms';
import metaData from 'marketing-website/data/metadata.js';
import AccountPagesWrap from 'marketing-website/components/modules/AccountPagesWrap';
import Page from 'marketing-website/components/modules/Page';
import Maintenance from 'marketing-website/components/modules/Maintenance';
import SigninForm from 'marketing-website/components/modules/SigninForm';

export default function Signin({ history, data }) {
  const pageProps = {
    title: metaData.signin.title,
    meta: [
      {
        name: 'description',
        content: metaData.signin.description,
      },
      { name: 'keywords', content: metaData.signin.keywords },
    ],
    header: false,
  };

  if (data.site.siteMetadata.siteMaintenance) {
    return (
      <Page {...pageProps}>
        <AccountPagesWrap history={history}>
          <Maintenance />
          <div />
        </AccountPagesWrap>
      </Page>
    );
  }

  const isCommenter = getCommenterParam();
  const redirectTo = getNextRedirectParam();

  const ssoLinkWithRedirect = getUrlWithRedirect('/sso');
  const signupLinkWithRedirect = getSignupUrlWithRedirect();

  const heading = isCommenter
    ? 'Sign in to leave a comment'
    : `${getTimeGreeting()}! Welcome back.`;

  const messaging = {
    header: (
      <Spacing type="margin" size="l" position="bottom">
        <Heading tag="h1" size="xxxl" weight="bold">
          {heading}
        </Heading>
      </Spacing>
    ),
  };

  return (
    <Page {...pageProps}>
      <AccountPagesWrap history={history}>
        <SigninForm redirectTo={redirectTo} messaging={messaging} />
        <Spacing type="margin" position="topBottom" size="m">
          <Paragraph size="m" color="slate">
            Secure sign in with{' '}
            <Link to={ssoLinkWithRedirect} tabIndex={10}>
              <MarvelLink type="blue">Enterprise SSO</MarvelLink>
            </Link>
          </Paragraph>
          <Paragraph size="m" color="slate">
            Don't have an account?{' '}
            <Link to={signupLinkWithRedirect} tabIndex={11}>
              <MarvelLink type="blue">Sign up</MarvelLink>
            </Link>
          </Paragraph>
        </Spacing>
      </AccountPagesWrap>
    </Page>
  );
}

export const SIGNIN_PAGE_QUERY = graphql`
  query SignInPageQuery {
    site {
      siteMetadata {
        siteMaintenance
      }
    }
  }
`;

function getTimeGreeting() {
  const hours = new Date().getHours();
  if (hours >= 5 && hours <= 12) {
    return 'Good morning';
  } else if (hours >= 13 && hours <= 17) {
    return 'Good afternoon';
  } else if (hours >= 18) {
    return 'Good evening';
  }
  return 'Hello';
}

Signin.propTypes = {
  history: PropTypes.object.isRequired,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        siteMaintenance: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/signin/index.js